import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'

import { DocumentLibraryOverlay } from '#app/routes/mocra+/_form+/components/document-libraries/overlay.tsx'
import {
	createDocumentLibraryDraft,
	type DocumentLibraryDraft,
} from '#app/routes/mocra+/_form+/components/document-libraries/types.ts'

type Props = {
	readonly onSubmit: (draft: DocumentLibraryDraft) => void
	readonly defaultValue?: DocumentLibraryDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function DocumentLibraryAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: DocumentLibraryDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add document library'}
			</AddButton>
			<DocumentLibraryOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createDocumentLibraryDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
